'use strict';

exports.__esModule = true;
exports.default = {
  box: {
    responsiveBreakpoint: 'small' // when we switch rows to columns
  },
  heading: {
    responsiveBreakpoint: 'small'
  },
  layer: {
    responsiveBreakpoint: 'small'
  }
};